import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { Image, theme, Text, Spinner } from 'ui'
import useStore from 'store'
import { observer } from 'mobx-react'
import {
    BrowserRouter as Router,
    Switch,
    useLocation
} from "react-router-dom";
import { Path } from 'core/Routes'
import { canEditCommunityModules } from 'utils/roles'
import { ExpandMore, Edit } from '@material-ui/icons'
import { useTranslation } from 'react-i18next'
import vls, { storageKeys } from 'utils/vls'
import { validURL } from 'utils/validations'


const StyledIframe = styled.iframe`
    border:none;
`
// Covers the iframe area with a spinner until the external site has painted,
// so the user never sees the blank mekome background flash before it loads.
const IframeLoadingOverlay = styled.div`
    position:absolute;
    inset:0;
    display:flex;
    align-items:center;
    justify-content:center;
    background-color:${theme.color.white};
    z-index:1;
`
const SideComponentMenu = styled.div`
    justify-content:center;
    align-items:center;
    display:flex;
    z-index:2000px;
    position:absolute;
    border-radius:12px;
    left:0;
    width:30px;
    height:30px;
    background-color:${theme.color.white};
    cursor:pointer;
`

const ItemText = styled(Text)`
    width:100%;
    padding:5px;
    align-items:center;
    justify-content:center;
    display:flex;
    :hover {
        background-color:${theme.color.black + '1A'} !important;
    }
`
const MenuContainer = styled.div`
    position:absolute;
    justify-content:center;
    align-items:center;
    display:flex;
    background-color:white;
    width:80px;
    height:80px;
    top:10px;
    left:10px;
    border-radius:12px;
`
const IframePortal: FC<{ type: string }> = ({ type }) => {
    const { modulesStore, orgs } = useStore()
    const portal = modulesStore?.communityModules.filter(i => i.type === type)
    let location = useLocation();
    const [show, setShow] = useState(false)
    useEffect(() => {
        if (location.pathname === (type === 'support' ? Path.SERVICECALL : Path.COMMUNITY)) {
            setShow(true)
        } else {
            setShow(false)
        }
    }, [location])
    const { t } = useTranslation(['budget'])
    const [showEdit, setShowEdit] = React.useState<boolean>(false)

    const src = validURL(portal[0]?.external_url || '') ? (portal[0]?.external_url || '') : ''
    // Keep a spinner over the iframe until it finishes loading the external site.
    const [iframeLoading, setIframeLoading] = useState(true)
    useEffect(() => {
        setIframeLoading(true)
        if (!src) return
        // Safety net: hide the overlay after a while even if onLoad never fires
        // (e.g. a portal that blocks the load event), so it can't hang forever.
        const timer = setTimeout(() => setIframeLoading(false), 15000)
        return () => clearTimeout(timer)
    }, [src])

    const userCanEditCommunityModules = canEditCommunityModules() && type !== 'portal'

    const openModuleModal = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        event.preventDefault()
        modulesStore.openModuleEditPortal(type)
        setShowEdit(false)
    }
    const onEnter = () => { setShowEdit(true) }
    const onLeave = () => { setShowEdit(false) }
    const onLoad = () => {
        setIframeLoading(false)
        // if (orgs.currentOrgId && location.pathname === Path.COMMUNITY) {
        //     const tokenCommunity = vls.get(storageKeys.tokenCommunity) || {}
        //     tokenCommunity[orgs.currentOrgId] = true
        //     vls.set(storageKeys.tokenCommunity, tokenCommunity)
        // }
    }
    return (
        <div style={{ width: show && '100%' || 0, height: show ? '100%' : 0, position: 'relative' }}>
            {show && src && iframeLoading && (
                <IframeLoadingOverlay><Spinner /></IframeLoadingOverlay>
            )}
            {userCanEditCommunityModules && <div style={{ position: 'relative', top: 10, left: 10 }}>
                {show && <div>
                    <SideComponentMenu
                        onMouseEnter={onEnter}
                        onMouseLeave={onLeave}
                    ><Edit />
                        {showEdit && <MenuContainer>
                            <ItemText
                                textcolor={theme.color.black + 80}
                                weight={'medium'}
                                size={'md'}
                                onClick={openModuleModal}>
                                {t`edit`}
                            </ItemText>
                        </MenuContainer>}
                    </SideComponentMenu>
                </div>}
            </div>}
            <StyledIframe
                style={{ width: '100%', height: '100%', order: 0 }}
                src={src}
                title="kibutz service"
                onLoad={onLoad}
                // When a portal has no SSO session (e.g. the user isn't registered
                // in the external system), some providers (webaxy/MAOF and others)
                // return a "user connection problem" error whenever they detect the
                // mekome referer. Drop the referer whenever SSO wasn't applied so the
                // portal serves its normal public page instead — i.e. open it like a
                // plain browser visit, no SSO. The authenticated path keeps the
                // referer + credential suffix, so working SSO is unaffected.
                referrerPolicy={portal[0]?.ssoApplied ? undefined : 'no-referrer'}
            />
        </div>
    )
}


export default observer(IframePortal)